// Tiny API client. Auth token comes from the signed-in session (Privy or dev login).
import { clientEnv } from "./env";
import { guestId } from "./identity";
import { authToken } from "./session";

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(typeof body === "object" && body && "error" in body ? String((body as { error: unknown }).error) : `HTTP ${status}`);
  }
}

export async function api<T = unknown>(method: string, path: string, body?: unknown, opts: { auth?: boolean; timeoutMs?: number } = {}): Promise<T> {
  if (!clientEnv.apiUrl) throw new ApiError(0, { error: "offline" });
  const headers: Record<string, string> = { "x-guest-id": guestId };
  if (body !== undefined) headers["content-type"] = "application/json";
  if (opts.auth !== false) {
    const t = await authToken();
    if (t) headers.authorization = `Bearer ${t}`;
  }
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), opts.timeoutMs ?? 15_000);
  try {
    const res = await fetch(`${clientEnv.apiUrl}${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), signal: ctl.signal });
    const json = await res.json().catch(() => null);
    if (!res.ok) throw new ApiError(res.status, json);
    return json as T;
  } finally {
    clearTimeout(timer);
  }
}
